<app-page-header [header]="getPageHeader()" [showBackButton]="false" />
<app-surgeries-private-list />